import { call, takeLatest, put } from "redux-saga/effects";
import { newRequest } from "../../../api/token";

import {
  GET_IPINFO_QUERY,
  GET_LANGUAGES_LIST_GQL,
  SET_AGENT_LANGUAGE_GQL,
} from "../../gqlQueries/variableQuery";
import {
  GetIPINFOAction,
  GetLanguageDataAction,
  setAgentLanguageDataAction,
} from "../../actions/variableAction";
import {
  GET_IPINFO_ACTIONTYPE,
  GET_LANGUAGES_LIST,
  SET_AGENT_LANGUAGE,
} from "../../actionTypes/variableActionTypes";
import { getToken, isGlobalApolloError } from "../../../utils/helpers/auth";
import { getAgentCreditLimitAction } from "../../actions/dashboardActions";
import { getNotificationMessage } from "../../actions/localStorageActions";
import engLang from "../../../locales/languages/Layout/LayoutEng.json";
import spanLang from "../../../locales/languages/Layout/LayoutSpan.json";
import { getLanguageCode } from "../../../locales/getlanguagecode";
import { UIMessage } from "../../../components/UI/UIMessage";

function* queryVariableSaga(): any {
  try {
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_LANGUAGES_LIST_GQL,
      clientType: "MO",
    });
    yield put(GetLanguageDataAction.FULLFILLED(queryResp));
  } catch (error) {
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.header
        ?.Network_Error_Message,
      closeIcon: true,
    });
    yield put(getNotificationMessage(UIMessage));
    yield put(GetLanguageDataAction.REJECTED(String(error)));
  }
}

function* queryIPINFOSaga(): any {
  try {
    const queryResp = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_IPINFO_QUERY,
    });
    if (queryResp?.data?.clientIpAddress) {
      yield put(GetIPINFOAction.FULLFILLED(queryResp?.data?.clientIpAddress));
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    UIMessage({
      messageText: getLanguageCode(engLang, spanLang)?.header
        ?.Network_Error_Message,
      closeIcon: true,
    });
    yield put(getNotificationMessage(UIMessage));
    yield put(GetIPINFOAction.REJECTED(String(error)));
  }
}

function* setAgentLanguage(action: any): any {
  const token = getToken() && getToken();
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    request: action?.payload?.request,
  };
  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: SET_AGENT_LANGUAGE_GQL,
      clientType: "MO",
      data: customHeaders,
    });
    if (
      apiData?.data?.updateUserLanguage?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      yield put(
        setAgentLanguageDataAction.FULLFILLED({
          ...action?.payload,
          ...apiData?.data?.updateUserLanguage,
        })
      );
      yield put(getAgentCreditLimitAction.STARTED(token));
    } else {
      const message = {
        isOpen: true,
        mainHeader: "Something went wrong",
        subHeader: "",
        message: "Failed to generate Booking Id",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    const message = {
      isOpen: true,
      mainHeader:
        "System taking too long to load the results. Check your network and try again",
      subHeader: "",
      message: "",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(setAgentLanguageDataAction.REJECTED(error));
  }
}

export function* watcherVariable() {
  yield takeLatest(GET_IPINFO_ACTIONTYPE.STARTED, queryIPINFOSaga);
  yield takeLatest(GET_LANGUAGES_LIST.STARTED, queryVariableSaga);
  yield takeLatest(SET_AGENT_LANGUAGE.STARTED, setAgentLanguage);
}

export const sagas = [watcherVariable];
